import { render, staticRenderFns } from "./ModalRemovedAdds.vue?vue&type=template&id=67faddd6&scoped=true"
import script from "./ModalRemovedAdds.vue?vue&type=script&lang=js"
export * from "./ModalRemovedAdds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67faddd6",
  null
  
)

export default component.exports